import { createSlice } from "@reduxjs/toolkit"
import { api } from './apiSlice'

export const integrationsApiSlice = api.injectEndpoints({
    endpoints: build => ({
        getAvailableAppIntegrations: build.query({
            query: () => ({
                url: '/partners/listings/integrations/available',
                method: 'GET'
            })
        }),
        getPartnerListingIntegrations: build.query({
            query: (partnerListingId) => ({
                url: `/partners/listings/${partnerListingId}/integrations`,
                method: 'GET',
                providesTags: (result, error, partnerListingId) => [
                    { type: 'PartnerListingIntegration', id: partnerListingId }
                ]
            })
        }),
        addGovxShopIntegration: build.mutation({
            query: integration => ({
                url: '/partners/listings/integrations/govxshop',
                method: 'POST',
                body: integration
            }),
            invalidatesTags: (result, error, integration) => [
                { type: 'PartnerListingIntegration', id: integration.partnerListingId },
                { type: 'Seller', id: integration.partnerListingId }
            ]
        }),
        updateGovxShopIntegration: build.mutation({
            query: integration => ({
                url: '/partners/listings/integrations/govxshop',
                method: 'PUT',
                body: integration
            }),
            invalidatesTags: (result, error, integration) => [
                { type: 'PartnerListingIntegration', id: integration.partnerListingId },
                { type: 'Seller', id: integration.partnerListingId }
            ]
        }),
        removeListingIntegration: build.mutation({
            query: ({ partnerListingId, integrationType }) => ({
                url: `/partners/listings/${partnerListingId}/integrations/${integrationType}`,
                method: 'DELETE',
                body: {}
            }),
            invalidatesTags: (result, error, integration) => [
                { type: 'PartnerListingIntegration', id: integration.partnerListingId },
                { type: 'Seller', id: integration.partnerListingId }
            ]
        }),
        checkManufacturerAvailability: build.query({
            query: ({ manufacturerId, partnerListingId }) => {
                const params = new URLSearchParams({ manufacturerId, partnerListingId })
                return {
                    url: `/partners/listings/integrations/govxshop/manufacturer-availability?${params}`,
                    method: 'GET',
                }
            },
        }),
        fetchListingCustomer: build.query({
            query: (listingId) => ({
                url: `netsuite/customer/listing/${listingId}`,
                method: 'GET',
            }),
        }),
        deleteListingCustomer: build.mutation({
            query: (listingId) => ({
                url: `netsuite/customer/listing/${listingId}`,
                method: 'DELETE',
            }),
        }),
        saveListingCustomer: build.mutation({
            query: customer => ({
                url: `netsuite/customer/listing/save`,
                method: 'POST',
                body: customer
            }),
        }),
        createListingCustomer: build.mutation({
            query: customer => ({
                url: `netsuite/customer/direct/sync`,
                method: 'POST',
                body: customer
            }),
        }),
        syncListingInvoiceToNetSuite: build.mutation({
            query: invoiceId => ({
                url: `netsuite/customer/invoice/sync/${invoiceId}`,
                method: 'POST'
            }),
        }),
        fetchNetSuiteInvoice: build.query({
            query: (invoiceId) => ({
                url: `netsuite/invoice/${invoiceId}`,
                method: 'GET',
            }),
        }),
    })
})

const initialState = []
const integrationsSlice = createSlice({
    name: 'integrations',
    initialState,
    reducers: {},
})

export const {
    useGetAvailableAppIntegrationsQuery,
    useGetPartnerListingIntegrationsQuery,
    useAddGovxShopIntegrationMutation,
    useUpdateGovxShopIntegrationMutation,
    useRemoveListingIntegrationMutation,
    useLazyCheckManufacturerAvailabilityQuery,
    useFetchListingCustomerQuery,
    useLazyFetchListingCustomerQuery,
    useDeleteListingCustomerMutation,
    useSaveListingCustomerMutation,
    useCreateListingCustomerMutation,
    useSyncListingInvoiceToNetSuiteMutation,
    useFetchNetSuiteInvoiceQuery,
    useLazyFetchNetSuiteInvoiceQuery,
} = integrationsApiSlice

export default integrationsSlice.reducer